"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _Portal = _interopRequireDefault(require("../HOC/Portal"));
var _Cross = _interopRequireDefault(require("../Icons/all/Cross"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _black = _interopRequireDefault(require("../tokens/color/black"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _green = _interopRequireDefault(require("../tokens/color/green"));
var _yellow = _interopRequireDefault(require("../tokens/color/yellow"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _ToastContainer = require("../ToastContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TOAST_TYPES = {
  top: {
    add: _ToastContainer.ADD_TOP_TOAST,
    remove: _ToastContainer.REMOVE_TOP_TOAST
  },
  bottom: {
    add: _ToastContainer.ADD_BOTTOM_TOAST,
    remove: _ToastContainer.REMOVE_BOTTOM_TOAST
  }
};
var Toast = function Toast(props) {
  var _props$text = props.text,
    text = _props$text === void 0 ? "" : _props$text,
    _props$show = props.show,
    show = _props$show === void 0 ? false : _props$show,
    _props$align = props.align,
    align = _props$align === void 0 ? "bottom" : _props$align,
    _props$type = props.type,
    type = _props$type === void 0 ? "default" : _props$type,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? _noop2["default"] : _props$onClose,
    _props$autoHideDurati = props.autoHideDuration,
    autoHideDuration = _props$autoHideDurati === void 0 ? 3 : _props$autoHideDurati,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className;
  var _useContext = (0, _react.useContext)(_ToastContainer.ToastContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  var topToasts = state.topToasts,
    bottomToasts = state.bottomToasts;
  var toasts = align == "top" ? topToasts : bottomToasts;
  var handleClose = (0, _react.useCallback)(function () {
    var fn = TOAST_TYPES[align].remove;
    dispatch(fn(node.current));
    onClose();
  });
  var node = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (show) {
      var fn = TOAST_TYPES[align].add;
      dispatch(fn(node.current));
    }
  }, [align, dispatch, show]);
  (0, _react.useEffect)(function () {
    if (show) {
      var timeOut = setTimeout(handleClose, autoHideDuration * 1000);
      return function () {
        return clearTimeout(timeOut);
      };
    }
  }, [autoHideDuration, handleClose, show]);
  var toastindex = toasts.indexOf(node.current);
  var length = toasts.length;
  var count = length - toastindex - 1;
  var getMargin = function getMargin() {
    return "calc(5% + (".concat(count, " * 6.5rem));");
  };
  return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(Toast.Wrapper, {
    className: className,
    show: show,
    position: align,
    type: type,
    margin: getMargin(),
    ref: node
  }, /*#__PURE__*/_react["default"].createElement(Toast.Span, null, text), /*#__PURE__*/_react["default"].createElement(_Cross["default"], {
    onClick: handleClose,
    showPointer: true,
    color: getColor(props)
  })));
};
Toast.propTypes = {
  text: _propTypes["default"].string,
  show: _propTypes["default"].bool.isRequired,
  align: _propTypes["default"].oneOf(["topRight", "topLeft", "top", "bottomRight", "bottomLeft", "bottom"]),
  onClose: _propTypes["default"].func.isRequired,
  autoHideDuration: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(["default", "success", "successSolid", "warning", "warningSolid", "error", "errorSolid", "darkDefault"]),
  className: _propTypes["default"].string
};
Toast.Span = _styledComponents["default"].span.withConfig({
  componentId: "sc-1yb42gd-0"
})(["margin-right:2rem;margin-top:0.2rem;font-size:1.8rem;@media (max-width:480px){font-size:1.4rem;}font-weight:300;"]);
Toast.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-1yb42gd-1"
})(["position:fixed;opacity:", ";visibility:", ";display:flex;transition:all 0.5s ease;justify-content:space-between;padding:1.8rem 1.8rem;width:max-content;min-width:50rem;max-width:900px;font-weight:300;border-radius:", ";background:", ";color:", ";", " z-index:20;@media (max-width:480px){max-width:95vw;min-width:95vw;margin:auto;}"], function (props) {
  return props.show ? "1" : "0";
}, function (props) {
  return props.show ? "visible" : "hidden";
}, _misc["default"].radius, function (props) {
  return getBackground(props);
}, function (props) {
  return getColor(props);
}, function (props) {
  return getPositionBasedStyles(props);
});
var backgrounds = {
  "default": _grey["default"].z100,
  success: _green["default"].z100,
  successSolid: _green["default"].z500,
  warning: _yellow["default"].z100,
  warningSolid: _yellow["default"].z500,
  error: _red["default"].z100,
  errorSolid: _red["default"].z500,
  darkDefault: _grey["default"].z900
};
var colors = {
  "default": _black["default"],
  success: _green["default"].z600,
  successSolid: _white["default"],
  warning: _yellow["default"].z600,
  warningSolid: _white["default"],
  error: _red["default"].z500,
  errorSolid: _white["default"],
  darkDefault: _white["default"]
};

// move below to helpers
var getColor = function getColor(props) {
  return colors[props.type || "default"] || _black["default"];
};
var getBackground = function getBackground(props) {
  return backgrounds[props.type || "default"] || _grey["default"].z100;
};
var getPositionBasedStyles = function getPositionBasedStyles(props) {
  return positionStyles[props.position || "bottom"] || bottomStyle;
};
var topRightStyle = function topRightStyle(props) {
  return "\n  right: ".concat(props.show ? "5%" : "-100%", "; // TODO\n  top: 10%;\n");
};
var topLeftStyle = function topLeftStyle(props) {
  return (0, _styledComponents.css)(["left:", ";top:10%;"], props.show ? "5%" : "-100%");
};
var topStyle = function topStyle(props) {
  return (0, _styledComponents.css)(["top:", ";left:50%;transform:translate(-50%,0);"], props.show ? props.margin : "-5%");
};
var bottomRightStyle = function bottomRightStyle(props) {
  return (0, _styledComponents.css)(["right:", ";bottom:10%;"], props.show ? "5%" : "-100%");
};
var bottomLeftStyle = function bottomLeftStyle(props) {
  return (0, _styledComponents.css)(["left:", ";bottom:10%;"], props.show ? "5%" : "-100%");
};
var bottomStyle = function bottomStyle(props) {
  return (0, _styledComponents.css)(["bottom:", ";left:50%;transform:translate(-50%,0);"], props.show ? props.margin : "-5%");
};
var positionStyles = {
  topRight: topRightStyle,
  topLeft: topLeftStyle,
  top: topStyle,
  bottomLeft: bottomLeftStyle,
  bottomRight: bottomRightStyle,
  bottom: bottomStyle
};
var _default = exports["default"] = Toast;